<template>
  <div :class="['sftp-files-collapse', ...classes]">
    <div class="sftp-files-collapse__outer">
      <div
        class="sftp-files-collapse__button"
        :class="isOpen && 'active'"
        @click="(isOpen = !isOpen), (key += 1)"
      >
        <font-awesome-icon icon="fa-solid fa-caret-right" class="arrow" />
        <div :key="folderIconKey">
          <font-awesome-icon
            :icon="`fa-light ${isOpen ? 'fa-folder-open' : 'fa-folder-closed'}`"
            class="folder"
          />
        </div>
      </div>
      <div class="d-flex flex-fill" @click="(isOpen = !isOpen), (key += 1)">
        <span class="sftp-files-collapse__name">
          {{ name }}
        </span>
      </div>
      <div class="sftp-files-collapse__date">
        <span>
          {{ creationDate }}
        </span>
      </div>
    </div>
    <el-collapse-transition>
      <div class="sftp-files-collapse__inner" v-if="isOpen">
        <slot name="inner"></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
export default {
  name: 'SFTPFilesCollapse',
  props: {
    name: {
      type: String,
      default: '',
    },
    creationDate: {
      type: String,
      default: '',
    },
    card: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key: 0,
      isOpen: false,
    };
  },
  computed: {
    classes() {
      return [this.card && 'sftp-files-collapse--card', this.isOpen && 'open'];
    },
    folderIconKey() {
      return `folder-icon-${this.name.slice(0, 3)}-${this.key}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.sftp-files-collapse {
  display: flex;
  flex-direction: column;
  padding: 0;
  padding-left: 62px;

  &--card {
    background: var(--card-background);
    border-radius: var(--border-radius);
    padding: 12px 24px;

    &.open {
      background: var(--light-bg);
      border: 1px solid var(--primary-secondary);

      & > .sftp-files-collapse__outer {
        font-weight: 400;
      }
    }

    & > .sftp-files-collapse__outer {
      font-weight: 600;
    }

    & > .sftp-files-collapse__inner {
      margin-right: 35px;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 16px;

    .arrow {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    .folder {
      font-size: 28px;
      width: 31.5px;
    }

    &.active {
      .arrow {
        transform: rotate(90deg);
        color: var(--primary-secondary);
      }

      .folder {
        color: var(--primary-secondary);
      }
    }

    i,
    svg {
      transition: 350ms ease-in-out;
    }
  }

  &__name {
    text-transform: uppercase;
  }

  &__date {
    width: 200px;
  }

  &__outer {
    display: flex;
    align-items: center;

    .outline-icon-button {
      font-size: 20px;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
  }
}
</style>
